module.exports = __webpack_public_path__ + "img/apply-avatar.c3242533.jpg";